import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { CustomIcon } from "components/icon/customIcon.component";
import { Text } from "components/Typography/text.styled";
import {
  SkillsWrapper,
  SkillTag,
  RoleAndSkillsContainer,
  DropDownRow,
  Row,
} from "./gigDetail.styled";
import { CompanyGig } from "model/Gig";

type Props = {
  gigData: CompanyGig;
};

export const GigDetailSkills: React.FC<Props> = ({ gigData }) => {
  const { t } = useTranslation();
  const [roleAndSkillsOpen, setRoleAndSkillsOpen] = useState(false);

  return (
    <>
      <DropDownRow
        onClick={() => {
          setRoleAndSkillsOpen(!roleAndSkillsOpen);
        }}
      >
        <Text
          fontFamily={FontFamily.MontserratRegular}
          fontSize={FontSize.Large}
        >
          {t("GigsCompany.Skills")}
        </Text>
        <CustomIcon
          name={roleAndSkillsOpen ? "upward_arrow" : "downward_arrow"}
          size="24px"
          color={Color.BurntSienna}
          style={{ marginTop: 10 }}
        />
      </DropDownRow>
      {roleAndSkillsOpen && (
        <RoleAndSkillsContainer>
          {gigData.skills.length > 0 && (
            <Row>
              <Text
                fontSize={FontSize.Standard}
                fontFamily={FontFamily.MontserratRegular}
              >
                {t("GigsCompany.SkillsWanted")}
              </Text>
              <SkillsWrapper>
                {gigData.skills.map((skill, index) => (
                  <SkillTag key={index}>
                    <Text
                      key={index}
                      color={Color.BurntSienna}
                      fontFamily={FontFamily.MontserratRegular}
                      fontSize={FontSize.Standard}
                      style={{ margin: 0 }}
                    >
                      {t(skill.skill, { ns: "skills" })}
                    </Text>
                  </SkillTag>
                ))}
              </SkillsWrapper>
            </Row>
          )}
        </RoleAndSkillsContainer>
      )}
    </>
  );
};
